import React from 'react';

const Header = ({ data, ui, language, onLanguageChange }) => {
   if (data) {
      var name = data.name;
      var occupation = data.occupation;
      var description = data.description;
      var networks = data.social.map((network) => {
         return <li key={network.name}><a href={network.url} target="_blank" rel="noopener noreferrer"><i className={network.className}></i></a></li>
      })
   }

   return (
      <header id="home">
         <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title={ui.navigation.show}>{ui.navigation.show}</a>
            <a className="mobile-btn" href="#home" title={ui.navigation.hide}>{ui.navigation.hide}</a>
            <ul id="nav" className="nav">
               <li><a className="smoothscroll" href="#home">{ui.navigation.home}</a></li>
               <li><a className="smoothscroll" href="#about">{ui.navigation.about}</a></li>
               <li><a className="smoothscroll" href="#resume">{ui.navigation.resume}</a></li>
               <li><a className="smoothscroll" href="#recommendations">{ui.navigation.recommendations}</a></li>
               <li><a className="smoothscroll" href="#contact">{ui.navigation.contact}</a></li>
               <li className="language-switcher" aria-label="Language">
                  <button className={language === 'pt' ? 'active' : ''} onClick={() => onLanguageChange('pt')} type="button">PT</button>
                  <span>/</span>
                  <button className={language === 'en' ? 'active' : ''} onClick={() => onLanguageChange('en')} type="button">EN</button>
               </li>
            </ul>
         </nav>

         <div className="row banner">
            <div className="banner-text">
               <h1 className="responsive-headline">{name}</h1>
               <h3><span>{occupation}</span>. {description}.</h3>
               <hr />
               <ul className="social">
                  {networks}
               </ul>
            </div>
         </div>

         <p className="scrolldown">
            <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
         </p>

      </header>
   );
};

export default Header;
